<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-12">
        <nested-viewproperty v-bind:date="date" v-bind:scheduleid="scheduleid" v-bind:elements="elements" v-bind:assigned="assigned" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "element-view-page-ending",
    components: {
      
    },
    props: {
      el: {
        type: Object,
        default: { Elements: [] }
      },
      date: {
        required: false,
        tyrrpe: String,
        default: null
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      assigned: {
        required: false,
        type: String,
        default: null
      },
      isshifttask: {
        required: false,
        type: Boolean,
        default: false
      },
      visible: {
        required: false,
        type: Boolean,
        default: true
      },
    },
    data() {
      return {

      };
    },
    methods: {
      openUrl(el,val) {
        this.$emit('openUrl', el, val);
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {

      }
    },
    computed: {
      elements: {
        get() {
          return this.el.Elements;
        }
      }
    },
    watch: {
     
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-viewing-elements/element-view-page-ending.vue